import { jsxs as p, jsx as i } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2361.js";
function a(l) {
  const { outline: e, fill: n, size: t } = o(l);
  return /* @__PURE__ */ p(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M1 0C0.447715 0 0 0.447715 0 1V14C0 14.5523 0.447716 15 1 15H3V4C3 3.44772 3.44772 3 4 3H14V1C14 0.447715 13.5523 0 13 0H1Z",
            fill: n
          }
        ),
        /* @__PURE__ */ i("path", { shapeRendering: "optimizeQuality", d: "M5 6H15V6.75H5V6Z", fill: e }),
        /* @__PURE__ */ i("path", { shapeRendering: "optimizeQuality", d: "M8 8H15V8.75H8V8Z", fill: e }),
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M5.11111 8H7.11111V8.75H5.11111V8Z",
            fill: e
          }
        ),
        /* @__PURE__ */ i("path", { shapeRendering: "optimizeQuality", d: "M11 10.75V10H15V10.75H11Z", fill: e }),
        /* @__PURE__ */ i("path", { shapeRendering: "optimizeQuality", d: "M5 10H10V10.75H5V10Z", fill: e }),
        /* @__PURE__ */ i(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 3H14V1C14 0.447715 13.5523 0 13 0H1C0.447715 0 0 0.447715 0 1V14C0 14.5523 0.447716 15 1 15H3V17C3 17.5523 3.44772 18 4 18H16C16.5523 18 17 17.5523 17 17V4C17 3.44772 16.5523 3 16 3ZM1 0.75H13C13.1381 0.75 13.25 0.861929 13.25 1V3H4C3.44772 3 3 3.44772 3 4V14.25H1C0.861929 14.25 0.75 14.1381 0.75 14V1C0.75 0.861929 0.861929 0.75 1 0.75ZM16 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V17C3.75 17.1381 3.86193 17.25 4 17.25H16C16.1381 17.25 16.25 17.1381 16.25 17V4C16.25 3.86193 16.1381 3.75 16 3.75Z",
            fill: e
          }
        )
      ]
    }
  );
}
a.__tags = [];
export {
  a as CopyIcon
};
//# sourceMappingURL=index.es252.js.map
